<template>
    <v-dialog
    v-model="localDialog"
    width="50%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span>{{ isEntryMode ? "Add Asset Assignment" : "Update Asset Assignment" }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="assetAssignmentSetup">
                    <v-row>
                        <v-col lg="6" md="6" cols="12">
                            <v-autocomplete
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="employee_id.value.value"
                            :error-messages="employee_id.errorMessage.value"
                            clearable
                            :items="getHrmEmployeeList"
                            :item-title="item => `${item.name}`"   
                            autocomplete="off"                                               
                            item-value="id"
                            :loading="employeeLoading"
                            
                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                    Employee <span class="text-red-accent-4">*</span>
                                </template> 
                            </v-autocomplete>
                        </v-col>

                        <v-col lg="6" md="6" cols="12">
                            <v-date-input
                            input-format="dd/mm/yyyy"
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="start_date.value.value"
                            :error-messages="start_date.errorMessage.value"
                            autocomplete="off"
                            clearable
                            >
                                <template #label>
                                Start Date
                                <span class="text-red-accent-4">*</span>
                                </template>
                            </v-date-input>
                        </v-col>

                        <v-col cols="12" class="pt-0 pb-4">
                            <v-textarea
                            label="Remarks"
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="remarks.value.value"
                            :error-messages="remarks.errorMessage.value"
                            clearable
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                            class="bg-red"
                            variant="flat"
                            type="reset"
                            @click="closeDialog"
                            >Close</v-btn
                            >
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl } from "@/store/api";
import { getCurrentInstance } from "vue";
import formattedDate from "@/plugins/dateFormatter";

const DEFAULT_IMAGE = '/src/assets/no_preview.jpeg';

export default {
    name: "AssetAssignmentSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                asset_register_id: null,
                employee_id: null,
                start_date: null,
                remarks: "",
            }),
        },
    },
    data() {
        return {
            mainId :null,
            localDialog: this.dialog,

            errorMessages: "",

            loading: false,
            employeeLoading:false,

            isEntryMode: true,
        };
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                console.log(newData)
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.asset_assignment_id.setValue(newData.id || "", false);
                this.asset_register_id.setValue(newData.asset_register_id || null, false);
                this.start_date.setValue(newData.start_date || null, false);
                this.employee_id.setValue(newData.employee_id || null, false);
                this.remarks.setValue(newData.remarks || "", false);
            },
        },
    },
    created() {
        // if(this.$store.getters.getHrmEmployeeList.length === 0) {
            this.employeeLoading = true,
            this.$store.dispatch("getHrmEmployeeList").then((response) => {
                this.employeeLoading = false;
            })
        // }
    },
    computed: {
        getHrmEmployeeList() {
            const employees = this.$store.getters.getHrmEmployeeList;
            return employees;
        }
    },
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                start_date: yup.string().trim().required("Name is required").max(255, "Name cannot exceed 255 characters").label("Name"),
                employee_id: yup.number().typeError("Employee must be selected").required("Employee is required").label("Employee"),
            }),
        });

        const asset_assignment_id = useField("asset_assignment_id");
        const asset_register_id =useField("asset_register_id");
        const employee_id = useField("employee_id");
        const start_date = useField("start_date");
        const remarks = useField("remarks");

        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();
        
        const submit = handleSubmit((values) => {
            const asset_id = proxy.mainId;
            values.asset_register_id = asset_id;
            values.start_date = formattedDate(start_date.value.value);
            store
                .dispatch("saveUpdateAssetAssignment", values)
                .then((response) => {
                    resetForm();
                    emit("update:dialog", false);
                    toast.success(response.data.message);
                    store.dispatch("getAssetAssignmentsList", { asset_register_id: asset_id });
                })
                .catch((error) => {
                    toast.error(error?.response?.data?.message || "Something went wrong");
                });
        });

        return {
            submit,
            asset_assignment_id,
            asset_register_id,
            employee_id,
            start_date,
            remarks,
            errorMessages,
            resetForm,
            loading,
        };
    },
    mounted() {
        const id = this.$route.params.id;
        this.mainId = id;
    },
};
</script>
